// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountDetailsStyles from "@steiner/App/SharedStyles/MyAccountDetailsStyles";
import { openBidsDetailsHeaderStyles } from "@steiner/App/Widgets/OpenBidsDetails/OpenBidsDetailsHeader";
import { css } from "styled-components";

openBidsDetailsHeaderStyles.headerGridContainer = {
    gap: 0,
};

openBidsDetailsHeaderStyles.title = {
    variant: "h3",
    as: "h1",
    css: css`
        @media print {
            font-size: 11px;
        }
    `,
};

openBidsDetailsHeaderStyles.buttonGridItem = {
    width: 12,
    css: css`
        gap: 16px 24px;
        flex-wrap: wrap;
        &.buttons-center {
            justify-content: center;
        }
    `,
};

openBidsDetailsHeaderStyles.actionWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
    `,
};
openBidsDetailsHeaderStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

openBidsDetailsHeaderStyles.addAllProductGroupLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.addAllToListClickable,
};

openBidsDetailsHeaderStyles.acceptBidButton = {
    css: css`
        width: 100%;
    `,
};

openBidsDetailsHeaderStyles.declineBidButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

openBidsDetailsHeaderStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
    `,
};